import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    agentObj: null,
    agentSnapshot: null,
    isAgentMute: false,
    softphoneError: "",
    maskNumber: "",
    isACW: false,
    MissingWrapCode:false,
    agentARN: "",
    agentAccount: "",
    isMonitoring: false
};

const agentSlice = createSlice({
    name: "agentSlice",
    initialState: initialState,
    reducers: {
        setAgentObj(state, action) {
            let payload = action.payload;
            state.agentObj = payload
        },
        agentSnapshot(state, action) {
            let payload = action.payload;
            state.agentSnapshot = payload;
        },
        setIsAgentMute(state, action) {
            let payload = action.payload;
            state.isAgentMute = payload
        },
        setMaskNumber(state, action) {
            let payload = action.payload;
            state.maskNumber = payload
        },
        setSoftphoneError(state, action) {
            let payload = action.payload;
            state.softphoneError = payload
        },
        setIsACW(state, action) {
            let payload = action.payload;
            state.isACW = payload
        },
        setIsMissingWrapCode(state, action) {
            let payload = action.payload;
            state.MissingWrapCode = payload
        },
        setAgentARN(state, action) {
            state.agentARN = action.payload.agentARN;
        },
        setAgentAccount(state, action) {
            state.agentAccount = action.payload.agentAccount;
        },
        setMonitoring(state, action) {
            state.isMonitoring = action.payload.isMonitoring;
        }
    },
});

export const agentSliceAction = agentSlice.actions;
export default agentSlice.reducer;